import React from 'react'
import {
  Form,
  Input,
  Row,
  Col,
  Select,
  DatePicker,
  Switch,
  Message,
} from 'antd'
import { postStore } from '../../../api/businessCommodity'
import '../Merchandise/style.css'
import moment from 'moment'

export default class extends React.Component {
  state = {
    storeId: '',
    quantity: '',
    producedDate: '',
    guaranteePeriod: '',
    guaranteePeriodType: '1',
    totalAmount: '',
    unitCost: '',
    expWarning: false,
    stockWarning: false,
    expWarningDays: '',
    stockWarningQuos: '',
    expDate: '',
  }

  componentDidMount() {}

  expWarningSwitch = (checked) => {
    this.setState({
      expWarning: checked,
      expWarningDays: '',
    })
  }

  stockWarningSwitch = (checked) => {
    this.setState({
      stockWarning: checked,
      stockWarningQuos: '',
    })
  }

  postNewStoring = async (flag) => {
    let isReady = false
    const {
      storeId,
      quantity,
      producedDate,
      guaranteePeriod,
      guaranteePeriodType,
      expDate,
      totalAmount,
      unitCost,
      expWarning,
      expWarningDays,
      stockWarning,
      stockWarningQuos,
    } = this.state
    if (
      (this.props.modalState == 'isAddCommodity' && this.props.isNonStandard) ||
      (this.props.modalState == 'isStore' &&
        this.props.chosenItem.isNonStandard)
    ) {
      if (storeId) {
        isReady = true
      } else {
        Message.error('请完整填写信息')
        return
      }
    } else {
      if (
        storeId &&
        quantity &&
        totalAmount &&
        unitCost &&
        (expWarning
          ? expWarningDays && guaranteePeriod && expDate
            ? true
            : false
          : true) &&
        (stockWarning ? (stockWarningQuos ? true : false) : true)
      ) {
        isReady = true
      } else {
        Message.error('请完整填写信息')
        return
      }
    }
    if (isReady) {
      let params = {}
      if (
        (this.props.modalState == 'isAddCommodity' &&
          this.props.isNonStandard) ||
        (this.props.modalState == 'isStore' &&
          this.props.chosenItem.isNonStandard)
      ) {
        params = {
          storeId: storeId,
          quantity: 99,
          producedDate: new Date(),
          guaranteePeriod: '',
          guaranteePeriodType: guaranteePeriodType,
          totalAmount: 0,
          unitCost: 0,
          expirationWaring: {
            isEnabled: false,
            days: '',
          },
          stockWaring: {
            isEnabled: false,
            quantity: '',
          },
          state: flag ? 1 : 2,
          description: '',
        }
      } else {
        params = {
          storeId: storeId,
          quantity: quantity,
          producedDate: producedDate || new Date(),
          guaranteePeriod: guaranteePeriod,
          guaranteePeriodType: guaranteePeriodType,
          totalAmount: totalAmount * 100,
          unitCost: unitCost * 100,
          expirationWaring: {
            isEnabled: expWarning,
            days: expWarningDays,
          },
          stockWaring: {
            isEnabled: stockWarning,
            quantity: stockWarningQuos,
          },
          state: flag ? 1 : 2,
          description: '',
        }
      }
      if (this.props.modalState == 'isAddCommodity') {
        params.listingId = this.props.newListingId
      } else if (this.props.modalState == 'isStore') {
        params.listingId = this.props.chosenItem.id
      }
      const { data, status, detail } = await postStore(params)
      if (status == 1) {
        Message.success('保存成功')
        this.props.setConfirmLoading(false)
        this.props.setIsVisible(false)
        this.props.getList()
      } else {
        Message.error(detail)
        this.props.setConfirmLoading(false)
      }
    }
  }

  computeExpDate = () => {
    setTimeout(() => {
      if (this.state.producedDate && this.state.guaranteePeriod) {
        let timeType = ''
        if (this.state.guaranteePeriodType == '1') {
          timeType = 'd'
        } else if (this.state.guaranteePeriodType == '2') {
          timeType = 'M'
        } else if (this.state.guaranteePeriodType == '3') {
          timeType = 'y'
        }
        this.setState({
          expDate: moment(this.state.producedDate)
            .add(this.state.guaranteePeriod, timeType)
            .format('YYYY-MM-DD'),
          // expWarning: true,
        })
      } else {
        this.setState({
          expDate: '',
          // expWarning: false,
        })
      }
    }, 500)
  }

  render() {
    const onChangeDate = (date, dateString) => {
      this.setState(
        {
          producedDate: dateString,
        },
        this.computeExpDate()
      )
    }
    const {
      storeId,
      quantity,
      guaranteePeriod,
      guaranteePeriodType,
      totalAmount,
      unitCost,
      expWarning,
      expWarningDays,
      stockWarning,
      stockWarningQuos,
      expDate,
    } = this.state

    const disabledDate = (current) => {
      return current && current > moment().endOf('day')
    }
    return (
      <Form labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
        <Form.Item
          label={
            <span>
              <span className="color_red">* </span>
              <span>所属仓库</span>
            </span>
          }
        >
          <Row gutter={8}>
            <Col span={14}>
              <Select
                value={storeId}
                onChange={(value) => {
                  this.setState({ storeId: value })
                }}
              >
                <Select.Option value="">选择仓库</Select.Option>
                {this.props.storeList &&
                  this.props.storeList.map((item, idx) => {
                    return (
                      <Select.Option value={item.id} key={item.id}>
                        {item.name}
                      </Select.Option>
                    )
                  })}
              </Select>
            </Col>
          </Row>
        </Form.Item>

        {(this.props.modalState == 'isAddCommodity' &&
          !this.props.isNonStandard) ||
        (this.props.modalState == 'isStore' &&
          !this.props.chosenItem.isNonStandard) ? (
          <div>
            <Form.Item
              label={
                <span>
                  <span className="color_red">* </span>
                  <span>进货数量</span>
                </span>
              }
            >
              <Row gutter={8}>
                <Col span={14}>
                  <Input
                    value={quantity}
                    onChange={(e) =>
                      this.setState({ quantity: e.target.value })
                    }
                  />
                </Col>
              </Row>
            </Form.Item>

            <Form.Item
              label={
                <span>
                  <span className="color_red">* </span>
                  <span>成本总价</span>
                </span>
              }
              style={{ marginBottom: 0 }}
            >
              <Row gutter={8}>
                <Col span={14}>
                  <Input
                    value={totalAmount}
                    onChange={(e) => {
                      if (quantity) {
                        this.setState({
                          totalAmount: e.target.value,
                          unitCost: (e.target.value / quantity).toFixed(2),
                        })
                      } else {
                        this.setState({ totalAmount: e.target.value })
                      }
                    }}
                  />
                </Col>
                <Col span={4} className="diamond">
                  元
                </Col>
              </Row>
            </Form.Item>

            <Row>
              <Col span={24} offset={5}>
                (成本输入栏选其一填写即可)
              </Col>
            </Row>

            <Form.Item
              label={
                <span>
                  <span className="color_red">* </span>
                  <span>成本单价(约)</span>
                </span>
              }
            >
              <Row gutter={8}>
                <Col span={14}>
                  <Input
                    value={unitCost}
                    onChange={(e) => {
                      if (quantity) {
                        this.setState({
                          unitCost: e.target.value,
                          totalAmount: e.target.value * quantity,
                        })
                      } else {
                        this.setState({
                          unitCost: e.target.value,
                        })
                      }
                    }}
                  />
                </Col>
                <Col span={4} className="diamond">
                  元
                </Col>
              </Row>
            </Form.Item>

            {/* <Form.Item label="成本单价">
              <span>
                {quantity && totalAmount
                  ? (totalAmount / quantity).toFixed(2)
                  : '/ '}
              </span>
              <span>元</span>
            </Form.Item> */}

            <Form.Item label="库存提醒">
              <Switch onChange={this.stockWarningSwitch} />
            </Form.Item>

            {stockWarning ? (
              <Form.Item
                label={
                  <span>
                    <span className="color_red">* </span>
                    <span>剩余</span>
                  </span>
                }
              >
                <Row gutter={8}>
                  <Col span={14}>
                    <Input
                      value={stockWarningQuos}
                      onChange={(e) =>
                        this.setState({ stockWarningQuos: e.target.value })
                      }
                    />
                  </Col>
                  <Col span={4} className="diamond">
                    提醒
                  </Col>
                </Row>
              </Form.Item>
            ) : null}

            <Form.Item
              label={
                <span>
                  {/* <span className="color_red">* </span> */}
                  <span>生产日期</span>
                </span>
              }
            >
              <Row gutter={8}>
                <Col span={14}>
                  <DatePicker
                    onChange={onChangeDate}
                    style={{ width: '100%' }}
                    disabledDate={disabledDate}
                  />
                </Col>
              </Row>
            </Form.Item>

            <Form.Item label={<span>保质期</span>}>
              <Row gutter={8}>
                <Col span={14}>
                  <Input
                    value={guaranteePeriod}
                    onChange={(e) =>
                      this.setState(
                        { guaranteePeriod: e.target.value },
                        this.computeExpDate()
                      )
                    }
                  />
                </Col>
                <Col span={3} className="diamond">
                  <Select
                    value={guaranteePeriodType}
                    onChange={(value) => {
                      this.setState(
                        { guaranteePeriodType: value },
                        this.computeExpDate()
                      )
                    }}
                  >
                    <Select.Option value="1">天</Select.Option>
                    <Select.Option value="2">月</Select.Option>
                    <Select.Option value="3">年</Select.Option>
                  </Select>
                </Col>
              </Row>
            </Form.Item>

            <Form.Item label={<span>过期日期</span>}>
              <Row gutter={8}>
                <Col span={14}>
                  <Input
                    value={expDate}
                    onChange={(e) => this.setState({ expDate: e.target.value })}
                  />
                </Col>
              </Row>
            </Form.Item>

            <Form.Item label="临期提醒">
              <Switch onChange={this.expWarningSwitch} />
            </Form.Item>

            {expWarning ? (
              <Form.Item
                label={
                  <span>
                    <span className="color_red">* </span>
                    <span>提前</span>
                  </span>
                }
              >
                <Row gutter={8}>
                  <Col span={14}>
                    <Input
                      value={expWarningDays}
                      onChange={(e) =>
                        this.setState({ expWarningDays: e.target.value })
                      }
                    />
                  </Col>
                  <Col span={4} className="diamond">
                    天提醒
                  </Col>
                </Row>
              </Form.Item>
            ) : null}
          </div>
        ) : null}
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/purchaseSalesInventory/components/storing.js